import React, {PropsWithChildren} from 'react';
import clsx from 'clsx';

import styles from './TableDetail.module.css';

interface PaymentDetailProps {
  className?: string
}


const TableDetail = (props: PropsWithChildren<PaymentDetailProps>) => {

  return (
    <div className={clsx(styles.root, props.className)}>
      {props.children}
    </div>
  );
};

export default TableDetail;
